export { default as revealHiddenDoor } from "./revealHiddenDoor";
